module.exports = __webpack_public_path__ + "img/9788989646693.8b43cbd7.jpg";